import router from "../router";
import services from "../services";
import Utils from "../Utils";

const strict = true;

const getDefaultState = () => {
  return {
    invoiceDoc: null,
    prescriptionDoc: null
  };
};

const state = getDefaultState();

const getters = {
  getInvoiceDoc: state => state.invoiceDoc,
  getPrescriptionDoc: state => state.prescriptionDoc
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_INVOICE_DOC(state, doc) {
    state.invoiceDoc = doc;
  },
  SET_PRESCRIPTION_DOC(state, doc) {
    state.prescriptionDoc = doc;
  }
};

const actions = {
  async storeInvoiceDoc({ commit }, doc) {
    await commit("SET_INVOICE_DOC", doc);
  },
  async uploadInvoiceDocument({ commit, rootGetters }, payload) {
    try {
      let OFFICE_ID = rootGetters["hfManagement/officeId"];
      payload.officeId = OFFICE_ID;
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      await services.billsService.addBillInvoiceDocument(payload);
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  async deleteInvoiceDocument({ commit, rootGetters }, payload) {
    try {
      let OFFICE_ID = rootGetters["hfManagement/officeId"];
      payload.officeId = OFFICE_ID;
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      await services.billsService.removeBillInvoiceDocument(payload);
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  async storePrescriptionDoc({ commit }, doc) {
    await commit("SET_PRESCRIPTION_DOC", doc);
  },
  async uploadPrescriptionDocument({ commit, rootGetters }, payload) {
    try {
      let OFFICE_ID = rootGetters["hfManagement/officeId"];
      payload.officeId = OFFICE_ID;
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      await services.billsService.addBillPrescriptionDocument(payload);
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  async deletePrescriptionDocument({ commit, rootGetters }, payload) {
    try {
      let OFFICE_ID = rootGetters["hfManagement/officeId"];
      payload.officeId = OFFICE_ID;
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      await services.billsService.removeBillPrescriptionDocument(payload);
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  async generateFascicoloBySingleDocuments(
    { commit, rootGetters },
    appointmentId
  ) {
    try {
      let officeId = rootGetters["hfManagement/officeId"];
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      await services.billsService.callGenerateFascicoloBySingleDocuments(
        officeId,
        appointmentId
      );
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      errorDialogDetails.type = Utils.errorTypes.STATUS;
      errorDialogDetails.dataName = "bills";
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  async openSuccessDialogAfterUpload({ commit, dispatch }, appointmentId) {
    let success = {
      title: "appointments.details.uploadFiles.success.title",
      message: "appointments.details.uploadFiles.success.message",
      closeButtonLabel: "appointments.details.uploadFiles.success.closeButton",
      closeButtonClb: () => {
        dispatch("bills/getProvidedServiceById", appointmentId, { root: true });
      }
    };
    commit("success/openSuccessDialog", success, {
      root: true
    });
  },
  async generateFascicoloByBulkDocuments({ commit, rootGetters }, billId) {
    try {
      let officeId = rootGetters["hfManagement/officeId"];
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      await services.billsService.callGenerateFascicoloByBulkDocuments(
        billId,
        officeId
      );
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  checkFascicoloGenerationByBulkDocuments(
    { commit, rootGetters, dispatch },
    payload
  ) {
    let timer;
    try {
      let officeId = rootGetters["hfManagement/officeId"];
      let billId = payload.billId;
      let result = false;
      timer = setInterval(function () {
        result =
          services.billsService.callCheckFascicoloGenerationByBulkDocuments(
            billId,
            officeId
          );
        result.then(hasFinished => {
          if (hasFinished) {
            clearInterval(timer);
            // open dialog
            dispatch(
              "openSuccessDialogAfterCheckFascicoloGenerationCompleted",
              payload
            );
          }
        });
      }, 4000);
    } catch (reason) {
      clearInterval(timer);
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  openSuccessDialogAfterCheckFascicoloGenerationCompleted(
    { commit, dispatch, rootGetters },
    payload
  ) {
    let billId = payload.billId;
    let billProtocolCode = payload.billProtocolCode;
    let billDetailLocation = "/workspace/bills/details/" + billId + "/";
    let lastPathLocation = rootGetters["bills/getLastPathLocation"];
    if (billDetailLocation === lastPathLocation) {
      // the user is still in the bill detail page, so need only to reload the bill detail page
      let success = {
        title: "bills.bill.documentsUpload.finishBulkGeneration.success.title",
        message: "bills.bill.documentsUpload.finishBulkGeneration.success.text",
        params: {
          msg: { billProtocolCode: billProtocolCode }
        },
        closeButtonLabel: "okButton",
        closeButtonClb: () => {
          dispatch("reloadBillDetail");
        }
      };
      commit("success/openSuccessDialog", success, {
        root: true
      });
    } else {
      // the user is in another page, so need to return into bill detail page if he wants, otherwise remains in the same page
      let confirm = {
        title: "bills.bill.documentsUpload.finishBulkGeneration.confirm.title",
        message: "bills.bill.documentsUpload.finishBulkGeneration.confirm.text",
        params: {
          msg: { billProtocolCode: billProtocolCode }
        },
        cancelBtnLabel: "okButton",
        cancelBtnClb: null,
        confirmBtnLabel: "proceedButton",
        confirmBtnClb: () => {
          dispatch("goBackAndReloadBillDetail", billId);
        }
      };
      commit("confirm/openConfirmDialog", confirm, {
        root: true
      });
    }
  },
  reloadBillDetail({ dispatch }) {
    dispatch("bills/getBill", null, { root: true });
  },
  goBackAndReloadBillDetail({ commit }, billId) {
    router.push({
      name: "_bills"
    });
    commit("bills/SET_ACTIVE_BILL_ID", billId, {
      root: true
    });
    router.push({
      name: "_billDetails",
      params: { id: billId }
    });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
